export function playAudio(src: string): HTMLAudioElement {
  const audio = new Audio();
  audio.src = src;
  audio.load();
  audio.play();
  return audio;
}

export function stopAudio(audio: HTMLAudioElement) {
  audio.pause();
}
